function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_2",
  "data-name": "Mask Group 2",
  transform: "translate(-366.882 -36.031)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bootstrap-fill",
  transform: "translate(366.398 36.031)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M236.251,184.176V172.621h8.338c4.558,0,7.223,2.141,7.223,5.794,0,3.757-2.829,5.761-8.263,5.761Zm0,17.621h8.89c5.546,0,8.478-2.248,8.478-6.45,0-4.145-3.045-6.314-8.834-6.314h-8.534Z",
  transform: "translate(-206.399 -150.802)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M18.81,0A18.736,18.736,0,0,0,.074,18.736V56.209A18.736,18.736,0,0,0,18.81,74.945H56.283A18.736,18.736,0,0,0,75.019,56.209V18.736A18.736,18.736,0,0,0,56.283,0H18.81Zm4.965,56.209V16.6H39.7c7.434,0,11.912,3.789,11.912,9.883a8.675,8.675,0,0,1-6.946,8.506v.468c5.354.548,8.918,4.361,8.918,9.523,0,6.97-5.078,11.223-13.528,11.223Z",
  transform: "translate(-0.074)"
})));

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.976,
    height: 74.945,
    viewBox: "0 0 73.976 74.945",
    transform: "translate(0 6)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/Bootstrap.f8a1ea7f.svg";
export { ForwardRef as ReactComponent };